export default {"src":"/_next/static/media/LILA.108e67e1.svg","height":18,"width":18};